import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5F6A7D",
      "fill-rule": "evenodd",
      d: "M5 10c0-4.977 4.06-9 9.053-9s9.052 4.023 9.052 9a8.9 8.9 0 0 1-.585 3.19l-.078.208v.004l.02.164.406 3.298c.019.152.04.325.045.475.006.166-.002.425-.125.695a1.5 1.5 0 0 1-.772.754 1.5 1.5 0 0 1-.698.11 6 6 0 0 1-.474-.057l-.027-.004-3.186-.467c-.088-.013-.135-.02-.169-.023h-.004l-.014.004c-.043.015-.101.036-.2.074a9.17 9.17 0 0 1-4.572.471 1 1 0 0 1 .301-1.977 7.17 7.17 0 0 0 3.612-.384c.141-.053.308-.115.46-.148.14-.029.258-.041.4-.042.156-.001.314.022.44.041l.037.006 2.925.428-.37-3.01-.005-.034c-.015-.123-.034-.276-.03-.426a2 2 0 0 1 .046-.386 3.3 3.3 0 0 1 .163-.486c.293-.769.454-1.604.454-2.478 0-3.86-3.151-7-7.052-7C10.15 3 7 6.14 7 10q0 .55.083 1.076a1 1 0 0 1-1.977.306A9 9 0 0 1 5 10",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#5F6A7D",
      "fill-rule": "evenodd",
      d: "M1.263 16.5c0-3.567 2.829-6.5 6.369-6.5a1 1 0 1 1 0 2c-2.39 0-4.369 1.992-4.369 4.5 0 .504.08.987.227 1.436l.018.055c.056.17.12.365.146.528.024.153.03.27.02.426-.01.164-.047.332-.078.47l-.008.04-.301 1.36 1.572-.215.036-.005c.124-.017.277-.038.423-.037.139.001.242.012.378.039.144.028.317.09.47.144l.05.017c.442.157.918.242 1.416.242a1 1 0 1 1 0 2 6.3 6.3 0 0 1-2.083-.356l-.224-.078-.022-.007h-.005l-.168.023-2.995.409a1 1 0 0 1-1.111-1.207l.611-2.762.041-.192-.007-.023c-.016-.055-.04-.13-.08-.25a6.6 6.6 0 0 1-.326-2.057",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#5F6A7D",
      "fill-rule": "evenodd",
      d: "M6.632 11a1 1 0 0 1 1-1C11.172 10 14 12.933 14 16.5S11.171 23 7.632 23a1 1 0 1 1 0-2C10.022 21 12 19.008 12 16.5S10.021 12 7.632 12a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }